<template>
  <v-container class="pa-4">
    <v-card outlined>
      <v-card-title>Upload e Pré-visualização de Imagens</v-card-title>
      <v-card-text>
        <!-- Campo de upload -->
        <v-file-input
          v-model="files"
          label="Selecione imagens"
          accept="image/*"
          multiple
          prepend-icon="mdi-image"
          show-size
          @change="previewImages"
        ></v-file-input>

        <!-- Galeria de pré-visualização -->
        <v-row>
          <v-col
            v-for="(img, index) in previews"
            :key="index"
            cols="12" sm="4" md="3"
          >
            <div style="border: 1 #000 solid;background: #E0F2F1;margin: 5px;padding: 10px; text-align: center;">
              <v-img
                :src="img"
                aspect-ratio="1"
                class="rounded"
                contain
              ></v-img>
              <strong>{{ files[index].name }}</strong><br>
              <span>{{ parseInt(files[index].size/1024) + " kB" }}</span><br>
              <span>{{ files[index].type }}</span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  <div>
    <!-- Adicionar 'multiple' ao input de arquivo -->
    <input type="file" accept="image/jpeg" @change="handleFileChange" multiple>
    <button @click="uploadAllSelectedFiles" :disabled="!selectedFiles.length || anyUploading">
      {{ anyUploading ? 'Enviando...' : 'Enviar Todos os Arquivos' }}
    </button>

    <!-- Exibição do status de cada arquivo -->
    <div v-if="uploads.length">
      <h3>Status dos Uploads:</h3>
      <div v-for="upload in uploads" :key="upload.id" style="border: 1px solid #ccc; padding: 10px; margin-bottom: 10px;">
        <p><strong>Arquivo:</strong> {{ upload.name }}</p>
        <p v-if="upload.uploading">Enviando... ({{ upload.progress ? upload.progress.toFixed(0) : 0 }}%)</p>
        <p v-if="upload.error" style="color: red;">Erro: {{ upload.error }}</p>
        <p v-if="upload.downloadURL">
          Sucesso! <a :href="upload.downloadURL" target="_blank">Ver</a>
          <img v-if="isImage(upload.downloadURL)" :src="upload.downloadURL" alt="Arquivo Enviado" style="max-width: 100px; margin-left: 10px;" />
        </p>
      </div>
    </div>
    <div v-if="globalError" style="color: red;">Erro Geral: {{ globalError }}</div>
  </div>
<v-row class="justify-center">
  <v-btn text @click="getBucketMetadata()">
    Verificar CORS
  </v-btn>
</v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'; // Para mapear o estado do Vuex mais facilmente

export default {
  name: "ImageUploader",
  data() {
    return {
      files: [],      // Arquivos selecionados
      previews: [],    // URLs para pré-visualização
      selectedFiles: [], // Agora um array de arquivos
      globalError: null, // Para erros não relacionados a um upload específico
    };
  },
  computed: {
    // Mapeia o estado 'uploads' do módulo 'upload'
    ...mapState('upload', ['uploads']),

    anyUploading() {
      // Verifica se algum upload está em andamento
      return this.uploads.some(u => u.uploading);
    },
  },
  methods: {
    previewImages() {
      // Limpa previews antigos
      this.previews.forEach(url => URL.revokeObjectURL(url));
      this.previews = [];

      if (!this.files || this.files.length === 0) return;

      // Gera URLs temporárias para cada imagem
      this.files.forEach(file => {
        if (file && file.type.startsWith("image/")) {
          let img = URL.createObjectURL(file)
          this.previews.push(img);
        }
        this.$store.dispatch("uploadFile", file)
      });
    },

    isImage(url) {
      return url && /\.(jpeg|jpg|png|gif)$/i.test(url);
    },
    handleFileChange(event) {
      const target = event.target;
      if (target.files && target.files.length > 0) {
        // Armazena todos os arquivos selecionados
        this.selectedFiles = Array.from(target.files);
        // Limpa estados anteriores chamando a mutation diretamente
        this.$store.commit('upload/RESET_ALL_UPLOADS');
        this.globalError = null;
      } else {
        this.selectedFiles = [];
      }
    },
    async uploadAllSelectedFiles() {
      if (!this.selectedFiles.length) {
        this.globalError = "Nenhum arquivo selecionado para enviar.";
        return;
      }

      this.globalError = null; // Limpa erros anteriores

      // Itera sobre cada arquivo selecionado e dispara a ação de upload
      for (const file of this.selectedFiles) {
        // Gerar um ID único para cada upload para rastreamento
        const uploadId = `${file.name}`;
        const filePath = `images/ImwvcZtgXVVvGapin0IulzBTQHk1/${uploadId}`; // Usar o ID no caminho para evitar colisões
        try {
          // Dispara a ação do Vuex para cada arquivo, passando o ID e o arquivo
          await this.$store.dispatch('upload/uploadFile', { id: uploadId, file: file, path: filePath });
        } catch (e) {
          console.error("Falha ao iniciar o upload para:", file.name, e);
          this.globalError = `Erro ao iniciar upload de ${file.name}.`;
          // O erro específico do arquivo será tratado dentro do Vuex
        }
      }
      this.selectedFiles = []; // Limpa os arquivos selecionados após iniciar os uploads
    },
    async getBucketMetadata() {
      await this.$store.dispatch("upload/getBucketMetadata")
    }
  },
  beforeUnmount() {
    // Libera memória ao destruir o componente
    this.previews.forEach(url => URL.revokeObjectURL(url));
  }
};
</script>

<style scoped>
.rounded {
  border-radius: 8px;
}
</style>
